import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Value = styled.h2`
  font-size: 16px;
  font-family: aria;
`;

export const Span = styled.span`
  text-align: left;
  line-height: 1.2;
  color: rgb(102, 102, 102);
  font-size: 14px;
  font-weight: 500;
  font-family: aria;
`;

export const Strong = styled.strong`
  font-weight: 800;
  font-family: aria;
`;
